import { ThemeContext } from 'contexts/theme-context'
import * as React from 'react'

function UserIconWithoutFill(props: React.SVGProps<SVGSVGElement>) {
  const { theme } = React.useContext(ThemeContext)

  return (
    <svg width={20} height={20} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M16.44 17.039c-.38-1.063-1.217-2.003-2.38-2.673-1.165-.67-2.592-1.033-4.06-1.033-1.467 0-2.893.363-4.058 1.033-1.164.67-2.001 1.61-2.38 2.673'
        stroke={theme === 'dark' ? 'white' : '#8E8E93'}
        fill='none'
        strokeWidth={2}
        strokeLinecap='round'
      />
      <circle cx={9.999} cy={6.666} stroke={theme === 'dark' ? 'white' : '#8E8E93'} fill='none' strokeWidth={2} strokeLinecap='round' r={3.333} />
    </svg>
  )
}

export default UserIconWithoutFill
